import styled, {css} from "styled-components";
import snsImg from "@PUBLIC/P/images/ico/ico_sns_pc.png";

interface SnsProps {
	sns: "facebook" | "twitter" | "kakaoStory" | "naver" | "kakaoTalk" | "email";
}

const ShareWrap = styled.div`
	display: flex;
	flex-direction: column;
`;
const SnsBtnList = styled.ul`
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 60px;
	margin-bottom: 20px;
`;
const SnsBtnItem = styled.li`
	+ li {
		margin-left: 10px;
	}
`;
const SnsBtnLink = styled.a<SnsProps>`
	display: block;
	width: 60px;
	height: 60px;
	background-image: url(${snsImg});
	background-position: ${props => {
		if (props.sns === "facebook") {
			return css`0 0`;
		}
		if (props.sns === "twitter") {
			return css`-70px 0`;
		}
		if (props.sns === "kakaoStory") {
			return css`-140px 0`;
		}
		if (props.sns === "naver") {
			return css`-210px 0`;
		}
		if (props.sns === "kakaoTalk") {
			return css`-280px 0`;
		}
		if (props.sns === "email") {
			return css`-350px 0`;
		}
	}};
	> span {
		font-size: 0;
	}
`;
const LinkInputBlock = styled.div`
	display: flex;
	align-items: center;
	flex: 0 0 auto;
	padding-top: 20px;
	> button {
		margin-left: 8px;
	}
`;

export {ShareWrap, SnsBtnList, SnsBtnItem, SnsBtnLink, LinkInputBlock};
